import { ObjectValues } from 'types';
import { SESSION_STORAGE_KEYS } from 'services/sessionStorageService';

export const AI_DRAFT_BANNER_STEP = {
  BUSINESS_INFO: 'business-info',
  STATEMENT_OF_INFORMATION: 'statement-of-information',
} as const;

export type AiDraftBannerStep = ObjectValues<typeof AI_DRAFT_BANNER_STEP>;

// Steps 1 and 2 get their own copy; steps 3-5 render no banner at all.
export const AI_DRAFT_BANNER_COPY: Record<AiDraftBannerStep, string> = {
  [AI_DRAFT_BANNER_STEP.BUSINESS_INFO]: 'draftedByAiReviewEachField',
  [AI_DRAFT_BANNER_STEP.STATEMENT_OF_INFORMATION]: 'draftedByAiCheckFigures',
};

// One storage entry per listing, holding the steps dismissed on it - so dismissing
// on one step leaves the other showing, and a listing's dismissals never pile up in
// a shared blob.
export const getDismissedBannersStorageKey = (listingId: string) =>
  `${SESSION_STORAGE_KEYS.DISMISSED_AI_DRAFT_BANNERS}:${listingId}`;
